import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { environment } from '../../../../../src/environments/environment';
import { createProfileConstants } from '../../../core/routing/services/profile/constants/create-profile.constant';
import { InstallationPackageService } from '../../../core/routing/services/installation-package/installation-package.service';
import { ProfileAPI } from '../../../core/routing/services/profile_api/constants/profile.constant';
import { WebsocketService } from '../../../core/routing/services/websocket/websocket.service';
import { Utils } from '../../../common/utils/utils';
import { CommonService } from '../../../common/services/common.service';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { DateFormatPipe } from '../../pipes/pipe-util/date-formate.pipe';

@Component({
  selector: 'iposcen-installation-package',
  templateUrl: './installation-package.component.html',
  styleUrls: ['./installation-package.component.scss'],
  providers: [DateFormatPipe]
})
export class InstallationPackageComponent implements OnInit, OnDestroy {
  @Input() iposliteEnabled: boolean;
  @ViewChild('confirmGenModal') confirmGenModal: ElementRef;
  tabIndex = 0;
  uwpDefaultPackage = environment.uwpDefaultPackage;
  operatingSystem = GlobalConstants.WINDOWS;
  profileId;
  generatePackageButton;
  linuxIPOSButton = GlobalConstants.LINUX_IPOS;
  generatePackageinProgress = GlobalConstants.GENERATE_PACKAGE_PROGRESS;
  packageNotification = GlobalConstants.PACKAGE_NOTIFICATION_TEXT;
  okButton = GlobalConstants.OK_BUTTON;
  installationPackageHeading = GlobalConstants.INSTALLATION_PACKAGE_HEADING;
  downloadPackageMessage = GlobalConstants.DOWNLOAD_PACKAGE_MESSAGE;
  profileIdHeading = GlobalConstants.PROFILE_ID_HEADING;
  win10SMessage = GlobalConstants.WIN10S_MESSAGE;
  win10SFooterMsg = GlobalConstants.WIN10S_FOOTER;
  win10SDescription3 = GlobalConstants.WIN10S_DESC3;
  profileStatus: string;
  isWindows10S: boolean;
  profileName: string;
  fullPkgName: string;
  downloadUrl: string;
  queryParam: any;
  packagetype: string;
  linuxIposQueryParam = ProfileAPI.LINUX_IPOS_QUERY_PARAM;
  fileExtension: string;
  installationRememberText = GlobalConstants.INTSALLATION_MESSAGE;
  installationProfileText = GlobalConstants.WINDOWS_DESC;
  installationPoint3 = GlobalConstants.PACKAGE_POINT3;
  installationPoint4 = GlobalConstants.PACKAGE_POINT4;
  downloadPackageName = GlobalConstants.DOWNLOAD_PACKAGE_TITLE;
  shareURLText = GlobalConstants.SHARE_URL_NAME;
  copyText = GlobalConstants.COPY_TEXT_NAME;
  userProfileId = GlobalConstants.USER_PROFILE_IDS;
  downloadClick = GlobalConstants.CLICK_DOWNLOAD;
  editProfileId: string;
  profileNameValue = GlobalConstants.PROFILE_NAME_LOWER_CASE;
  profileSettings: any; // For GA
  customHeroTiles: any;  // For GA
  isChromeOs: boolean;
  isLastPushStatusPackage = false;
  confirmModalTitle: string;
  confirmModalDesc: string;
  confirmModalCTA: string;
  latestProfilePushTime: string;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private googleAnalyticsService: GoogleAnalyticsService,
    private createProfileService: CreateProfileService,
    private router: Router,
    private installationPackageService: InstallationPackageService,
    private webSocketConn: WebsocketService,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private dateFormatePipe: DateFormatPipe) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.editProfileId = params.profileId;
    });
    this.getProfileInfo();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  generatePackage(queryParam?: string) {
    this.tabIndex = 1;
    if (queryParam) {
      this.packagetype = ProfileAPI.LINUX_IPOS_QUERY_PARAM;
    }
    this.prepareQueryParamData();
    this.createProfileService.emitPackageInstallation(true);
    this.googleAnalyticsService.createNewInstallationPackage(this.profileId, this.profileName); //for GA
    this.installationPackageService.generateInstalltionPackage(this.profileId, this.queryParam)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => data,
        error => {
          Utils.handleError(error, this.constructor.name)
        });
    //IIT2-17363
    this.createProfileService.getProfileDetailsById(this.profileId)
      .subscribe(profileData => {
        let tempSettings = JSON.parse(profileData.profile?.settings);
        let dataObj = {
          profile_id: this.profileId,
          profile_name: profileData.profile?.profileName,
          os_type: tempSettings?.otherSettings?.operatingSystem,
          package_type: tempSettings?.otherSettings?.contentTypes?.packagedTypes,
          package_status_idle_experience: tempSettings?.otherSettings?.increasePromotionRotation ? 'increase_Promotion_Rotation' : tempSettings?.idleExperience?.IdleDisplay,
        }
        if (dataObj.package_status_idle_experience == 'Fact Tag Rotation') {
          let val =
            tempSettings?.idleExperience?.isLogoContentEnabled && tempSettings?.idleExperience?.isSegmentContentEnabled ? 'Included_Logo_Content_Groups_nd_Include_Segment_Content_Groups' :
              tempSettings?.idleExperience?.isLogoContentEnabled ? 'Included_Logo_Content_Groups' :
                tempSettings?.idleExperience?.isSegmentContentEnabled ? 'Included_Segment_Content_Groups' : 'unset'
          dataObj['package_status_Idle_fact_tag_rotation'] = val;
        } else if (dataObj.package_status_idle_experience == 'AttractLoop') {
          let attarctVal = tempSettings?.idleExperience?.isStandard4kVideoIncluded && profileData.profile?.attractLoop ? 'is4kVideoselected_nd_Retailer_Attractloop' :
            tempSettings?.idleExperience?.isStandard4kVideoIncluded ? 'is4kVideoselected' :
              profileData.profile?.attractLoop ? 'Retailer_Attractloop' : 'unset'
          dataObj['package_status_attract_loop_enabled'] = attarctVal;
        }
        this.googleAnalyticsService.packageIdleExperienceInformation(dataObj);
      });
  }

  generateLastestPushUpdatePackage(queryParam?: string) {
    if (this.isLastPushStatusPackage) {
      let latestPushedTime = this.dateFormatePipe.transform(this.latestProfilePushTime, 'changeToLocalTime');
      this.confirmModalTitle = GlobalConstants.PUSH_GEN_POPUP_TITLE;
      this.confirmModalDesc = latestPushedTime;
      this.confirmModalCTA = GlobalConstants.GENERATE;
      this.openModal(this.confirmGenModal);
    } else {
      this.generatePackage(queryParam);
    }
  }
  prepareQueryParamData() {
    this.operatingSystem = (this.operatingSystem === ProfileAPI.LINUX) ? ProfileAPI.LINUX : ProfileAPI.WINDOWS;
    if (this.iposliteEnabled) this.operatingSystem = this.packagetype = GlobalConstants.IPOS_LITE;
    const queryParam = [
      ProfileAPI.PACKAGE, this.operatingSystem, this.packagetype
    ];
    this.queryParam = queryParam;
  }

  getProfileInfo() {
    const profileId = this.editProfileId || this.createProfileService.getProfileId();
    this.profileId = profileId;
    this.createProfileService.getProfileDetailsById(profileId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(profileDetailsresponse => {
        const profileDetails = profileDetailsresponse.profile;
        if (JSON.parse(profileDetails?.retailerConfiguartion)?.customSrtEnabled) {
          if (profileDetails?.customHeroTiles?.length) {
            this.customHeroTiles = profileDetails?.customHeroTiles;
          }
        }
        const operatingSystem = Utils.getOperatingSystemTypeFromServer(JSON.parse(profileDetails.settings)?.otherSettings?.operatingSystem);
        this.operatingSystem = (operatingSystem.includes('Linux')) ? ProfileAPI.LINUX : operatingSystem;
        this.isChromeOs = (operatingSystem.includes('Chrome')) ? true : false;
        this.profileStatus = profileDetails.packageStatus;
        this.profileName = profileDetails.profileName;
        this.latestProfilePushTime = profileDetails.latestProfilePushTime;
        this.isLastPushStatusPackage = profileDetails?.latestProfilePushTime ? true : false;
        if (profileDetails.packageStatus === GlobalConstants.COMPLETED_STATUS) {
          this.tabIndex = 2;
          this.fullPkgName = decodeURIComponent(profileDetails.pkgDownloadUrl.split(/[/ ]+/).pop());
          let checkExt = this.fullPkgName.split(/[. ]+/);
          const fileExt = checkExt[checkExt.length - 1];
          this.fileExtension = '.' + fileExt;
        }
        this.profileSettings = profileDetails?.settings;
        this.setGeneratePackageButtonText(this.operatingSystem, profileDetails);
      },
        error => {
          Utils.handleError(error, this.constructor.name);
        });
  }
  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  setGeneratePackageButtonText(operatingSystem, profDetail) {
    switch (operatingSystem) {
      case (GlobalConstants.WINDOWS):
        this.packagetype = ProfileAPI.WINDOWS_QUERY_PARAM;
        this.generatePackageButton = GlobalConstants.GENERATE_PACKAGE;
        this.isWindows10S = false;
        this.fileExtension = GlobalConstants.FILE_EXTENSION_MSI;
        this.downloadUrl = profDetail.pkgDownloadUrl || '';
        break;
      case (GlobalConstants.WINDOWS_10S):
        this.packagetype = ProfileAPI.WINDOWS_10S_QUERY_PARAM;
        this.generatePackageButton = GlobalConstants.GENERATE_INSTALLER_PACKAGE;
        this.isWindows10S = true;
        this.fileExtension = GlobalConstants.FILE_EXTENSION_ZIP;
        this.downloadUrl = profDetail.pkgDownloadUrl || '';
        break;
      case (GlobalConstants.CHROME_TEXT):
        this.packagetype = ProfileAPI.CHROME_QUERY_PARAM;
        this.generatePackageButton = GlobalConstants.GENERATE_PACKAGE;
        this.isWindows10S = false;
        this.fileExtension = GlobalConstants.FILE_EXTENSION_ZIP;
        this.downloadUrl = profDetail.pkgDownloadUrl || '';
        break;// FOR CHROME TYPE
      case (GlobalConstants.LINUX):
        this.packagetype = ProfileAPI.LINUX_ISO_QUERY_PARAM;
        this.generatePackageButton = GlobalConstants.LINUX_ISO;
        this.isWindows10S = false;
        this.downloadUrl = profDetail.pkgDownloadUrl || '';
        const fileExt = profDetail.pkgDownloadUrl.split('/').pop().split('.')[1];
        this.fileExtension = '.' + fileExt;
        if (this.fileExtension === '.0_amd64') {
          this.fileExtension = GlobalConstants.FILE_EXTENSION_DEB;
        }
        break;
      default: { }
    }
  }
  downloadPackage() {
    this.commonService.downloadPackage(this.downloadUrl, this.fullPkgName, this.fileExtension);
  }
  copyPackageURL(inputElement) {
    inputElement.select();
    document.execCommand(GlobalConstants.COPY_TEXT);
    inputElement.setSelectionRange(0, 0);
  }

  packageInstallationInprogess() {
    this.createProfileService.emitPackageInstallation(false);
    this.router.navigate([createProfileConstants.PROFILE]);
  }

  confirmGenerateProfile() {
    this.generatePackage();
    this.closeModal(this.confirmGenModal);
  }
}
